/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Clamps a number between a minimum and maximum value (inclusive).
 */
const clamp = (num, min, max) => Math.min(max, Math.max(min, num));

export { clamp };
